module.exports = __webpack_public_path__ + "assets/img/home31.36ea4bc5.png";